import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-pwd-change',
  templateUrl: './pwd-change.component.html',
  styleUrls: ['./pwd-change.component.scss']
})
export class PwdChangeComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["pwd_container"];
  @Input() IsPopup: boolean = false;
  @Input() UserId: string = '';
  @Output() onChanged = new EventEmitter();
  minPwdLength = 6;
  elementIds: any = {
    save: 'pwd_change_save',
    pwd: 'pwd_change_pwd',
    pwd_confirm: 'pwd_change_pwd_confirm',
  };
  txtNewPwd: string = ''; txtNewPwdConfirmed: string = '';
  message: string = ''; isRedAlert: boolean = true;

  constructor(public localService: LocalService, public profileManagementService: ProfileManagementService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
    }, 1000);
  }

  onSave() {
    if (this.doCheck()) {
      this.profileManagementService.savePwd(this.UserId, this.txtNewPwd).subscribe(result => {
        if (result.status == Status.Success) {
          this.onChanged.emit(this.txtNewPwd);
        }
      });
    }
  }

  doCheck() {
    let message = '';
    this.txtNewPwd = this.txtNewPwd.trim();
    this.txtNewPwdConfirmed = this.txtNewPwdConfirmed.trim();
    if (this.txtNewPwd.length < this.minPwdLength) {
      message = this.localService.languageContent.pwd_container.need_min_pwd_length;
      this.localService.onFocusNextInput(this.elementIds.pwd, FocusInputType.TextBox);
    } else if (this.txtNewPwd != this.txtNewPwdConfirmed) {
      message = this.localService.languageContent.pwd_container.pwd_confirm_pwd_didnt_match;
      this.localService.onFocusNextInput(this.elementIds.pwd_confirm, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }
}
